<div
  class="stepper-container"
  [ngClass]="{
    'wk-padding-all-24': !isAgendaCompleted,
    'no-border-top': isAgendaCompleted
  }"
>
  <ng-content select="[content]"></ng-content>
</div>
